import { IonSkeletonText } from "@ionic/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

// TopoJSON data for the world map
const geoUrl = "/assets/geojson/world.json";

interface NeoMapProps {
  visitedCountries?: string[]; // Array of ISO Alpha-3 codes
  title?: string;
  loading?: boolean;
  className?: string;
}

const NeoMap: React.FC<NeoMapProps> = ({
  visitedCountries = ["FRA", "USA", "JPN", "ITA", "AUS"],
  loading = false,
  className = ""
}) => {
  const { t } = useTranslation();
  const [tooltipContent, setTooltipContent] = useState("");
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  if (loading) {
    return (
      <div className={`w-full ${className}`}>
        <IonSkeletonText animated className="h-64 w-full rounded-md" />
      </div>
    );
  }

  return (
    <div className={`w-full ${className}`}>
      <div className="overflow-hidden bg-card rounded-xl">
        <ComposableMap
          projectionConfig={{
            rotate: [0, 0, 0],
            center: [0, 40],
            scale: 100
          }}
          capHeight={450}
          height={450}
          projection="geoMercator"
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => {
                const isVisited = visitedCountries.includes(geo.id);
                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={isVisited ? "hsl(var(--primary))" : "#d7d7d7"}
                  />
                );
              })
            }
          </Geographies>
        </ComposableMap>

        {/* Tooltip */}
        {tooltipContent && (
          <div
            className="fixed bg-background text-foreground px-3 py-2 rounded-md shadow-lg text-sm pointer-events-none z-50 border border-primary/20"
            style={{
              left: `${tooltipPosition.x}px`,
              top: `${tooltipPosition.y - 40}px`,
              transform: 'translate(-50%, -100%)',
              fontWeight: 'bold'
            }}
          >
            {tooltipContent}
          </div>
        )}
      </div>
      <div className="flex justify-center items-center mt-2 text-sm text-muted-foreground">
        <span className="inline-block w-3 h-3 rounded-full bg-primary mr-2"></span>
        <h2 className="text-sm font-medium">{t('visited_countries', { count: visitedCountries.length })}</h2>
      </div>
    </div>
  );
};

export default NeoMap;
